import { useSelector } from 'react-redux';
import { userSelectors } from '@/Redux/User';
import { UserSegmentType } from '@/Enums';

export function useUserHasMarketSegment() {
  const user = useSelector(userSelectors.currentUser);

  return user?.segment === UserSegmentType.MarketUser;
}
